import React, { forwardRef } from 'react';
import '../../styles/vendorregistration.css';
import { useTranslation } from 'react-i18next';

const VendorDetailsPage = forwardRef((props, ref) => {
  const {
    formData,
    updateFormData,
    errors,
    handleFieldFocus,
    registerFieldRef
  } = props;
  const { t } = useTranslation();

  const handleChange = (e) => {
    const { id, value } = e.target;
    updateFormData('vendorDetails', id, value);
  };

  const handleAccreditationChange = (e) => {
    const value = e.target.value;
    updateFormData('vendorDetails', 'accreditation', value);
    handleFieldFocus('vendorDetails', 'accreditation');
  };

  const handleRegNumberChange = (e) => {
    const value = e.target.value;
    updateFormData('vendorDetails', 'reg_number', value);
    handleFieldFocus('vendorDetails', 'reg_number');
  };

  return (
    <div ref={ref} className="form-section">
      <h2 className="page-title">{t('vendorRegistration.headers.step3')}</h2>
      <p className="page-description">{t('vendorRegistration.subdescriptions.step3')}</p>

      <div className="form-grid">
        <div className="form-group">
          <label htmlFor="accreditation">{t('vendorRegistration.formLabels.accreditation')}</label>
          <div className="input-container">
            <input
              type="text"
              maxLength="50"
              id="accreditation"
              placeholder={t('vendorRegistration.formLabels.accreditation')}
              value={formData.vendorDetails.accreditation || ''}
              onChange={handleAccreditationChange}
              ref={(el) => registerFieldRef('accreditation', el)}
              className={errors.vendorDetails?.accreditation ? 'error' : ''}
            />
            {errors.vendorDetails?.accreditation && (
              <div className="error-message">
                {t(`vendorRegistration.errors.${errors.vendorDetails.accreditation}`)}
              </div>
            )}
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="reg_number">{t('vendorRegistration.formLabels.regNumber')}</label>
          <div className="input-container">
            <input
              type="text"
              id="reg_number"
              maxLength="50"
              placeholder={t('vendorRegistration.formLabels.regNumber')}
              value={formData.vendorDetails.reg_number || ''}
              onChange={handleRegNumberChange}
              ref={(el) => registerFieldRef('reg_number', el)}
              className={errors.vendorDetails?.reg_number ? 'error' : ''}
              disabled={!formData.vendorDetails.accreditation?.trim()}
              style={{
                opacity: !formData.vendorDetails.accreditation?.trim() ? 0.6 : 1
              }}
            />
            {errors.vendorDetails?.reg_number && (
              <div className="error-message">
                {t(`vendorRegistration.errors.${errors.vendorDetails.reg_number}`)}
              </div>
            )}
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="website">{t('vendorRegistration.formLabels.website')}</label>
          <div className="input-container">
            <input
              type="url"
              id="website"
              placeholder="https://www.example.com"
              value={formData.vendorDetails.website || ''}
              onChange={(e) => { handleChange(e); handleFieldFocus('vendorDetails', 'website') }}
              ref={(el) => registerFieldRef('website', el)}
              className={errors.vendorDetails?.website ? 'error' : ''}
            />
            {errors.vendorDetails?.website && (
              <div className="error-message">{t(`vendorRegistration.errors.${errors.vendorDetails?.website}`)}</div>
            )}
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="established_year">{t('vendorRegistration.formLabels.establishedYear')}</label>
          <div className="input-container">
            <input
              type="text"
              placeholder={t('vendorRegistration.formLabels.establishedYear')}
              id="established_year"
              maxLength="4"
              value={formData.vendorDetails.established_year || ''}
              onChange={(e) => { handleChange(e); handleFieldFocus('vendorDetails', 'established_year') }}
              ref={(el) => registerFieldRef('established_year', el)}
              className={errors.vendorDetails?.established_year ? 'error' : ''}
            />
            {errors.vendorDetails?.established_year && (
              <div className="error-message">{t(`vendorRegistration.errors.${errors.vendorDetails?.established_year}`)}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});

export default VendorDetailsPage;